(function(){
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var ov=$('[data-cd-overlay]'),cd=$('[data-cd-drawer]');
if(!ov||!cd)return;
var CUR=(window.GW&&GW.cur)||'TRY';
var money=function(c){var w=c%100===0;if(CUR==='TRY')return (c/100).toLocaleString('tr-TR',{minimumFractionDigits:w?0:2,maximumFractionDigits:w?0:2})+' ₺';try{return (c/100).toLocaleString('en-US',{style:'currency',currency:CUR})}catch(e){return (c/100).toFixed(2)+' '+CUR}};
var needShip=+(cd.dataset.needShip||0);
var busy=false;

function syncHeaderCount(n){$$('[data-cart-count]').forEach(function(e){e.textContent=n})}

function openDrawer(){
 document.body.classList.add('cd-open');ov.hidden=false;
 requestAnimationFrame(function(){ov.classList.add('show');cd.classList.add('open')});
 cd.setAttribute('aria-hidden','false')
}
function closeDrawer(){
 ov.classList.remove('show');cd.classList.remove('open');cd.setAttribute('aria-hidden','true');
 setTimeout(function(){ov.hidden=true;document.body.classList.remove('cd-open')},320)
}
ov.addEventListener('click',closeDrawer);
$$('[data-cd-close]',cd).forEach(function(b){b.addEventListener('click',closeDrawer)});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cd.classList.contains('open'))closeDrawer()});

function imgSrc(url){if(!url)return'';return url.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/,'_180x180_crop_center$1$2')}

function renderItem(it){
 var div=document.createElement('div');div.className='cd-ci';
 var img=document.createElement('img');img.loading='lazy';img.alt='';img.src=imgSrc(it.image);
 var t=document.createElement('div');t.className='cd-ci-t';
 var b=document.createElement('b');b.textContent=it.product_title;t.appendChild(b);
 if(it.variant_title&&it.variant_title!=='Default Title'){var sm=document.createElement('small');sm.textContent=it.variant_title;t.appendChild(sm)}
 var q=document.createElement('div');q.className='cd-ci-q';
 var mBtn=document.createElement('button');mBtn.type='button';mBtn.textContent='−';mBtn.setAttribute('aria-label','Azalt');
 var qs=document.createElement('span');qs.textContent=it.quantity;
 var pBtn=document.createElement('button');pBtn.type='button';pBtn.textContent='+';pBtn.setAttribute('aria-label','Artır');
 mBtn.addEventListener('click',function(){changeQty(it.key,it.quantity-1)});
 pBtn.addEventListener('click',function(){changeQty(it.key,it.quantity+1)});
 q.appendChild(mBtn);q.appendChild(qs);q.appendChild(pBtn);t.appendChild(q);
 var p=document.createElement('div');p.className='cd-ci-p';p.textContent=money(it.final_line_price);
 var rm=document.createElement('button');rm.type='button';rm.className='cd-ci-x';rm.textContent='Kaldır';
 rm.addEventListener('click',function(){changeQty(it.key,0)});
 div.appendChild(img);div.appendChild(t);div.appendChild(p);div.appendChild(rm);
 return div
}

function render(cart){
 var wrap=$('[data-cd-items]');wrap.innerHTML='';
 syncHeaderCount(cart.item_count);
 var cnt=$('[data-cd-count]');if(cnt)cnt.textContent='('+cart.item_count+')';
 if(!cart.item_count){
  var p=document.createElement('p');p.className='cd-empty';p.textContent='Sepetiniz henüz boş.';wrap.appendChild(p)
 } else {
  cart.items.forEach(function(it){wrap.appendChild(renderItem(it))})
 }
 $$('[data-cd-total],[data-cd-total-2]').forEach(function(e){e.textContent=money(cart.total_price)});
 var discRow=$('[data-cd-disc]');
 if(discRow){if(cart.total_discount>0){discRow.hidden=false;var dv=$('[data-cd-disc-v]',discRow);if(dv)dv.textContent='−'+money(cart.total_discount)}else discRow.hidden=true}
 if(needShip>0){
  var toys=cart.item_count,txt=$('[data-cd-ship-txt]'),bar=$('[data-cd-ship-bar]');
  if(txt&&bar){
   if(toys<needShip){txt.innerHTML=(needShip-toys)+' ürün daha ekleyin, kargo <b>ücretsiz</b> olsun';bar.style.width=Math.round(toys*100/needShip)+'%'}
   else{txt.innerHTML='Ücretsiz kargo kazandınız 🎉';bar.style.width='100%'}
  }
 }
}
function fetchCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
function refresh(){return fetchCart().then(render)}
function changeQty(key,q){
 if(busy)return;busy=true;
 return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
  .then(function(r){return r.json()}).then(function(cart){render(cart);busy=false})
  .catch(function(){busy=false})
}
function renderUpsell(){
 var row=$('[data-cd-upsell-row]'),wrap=$('[data-cd-upsell]'),raw=$('#cd-upsell-data');
 if(!row||!wrap||!raw)return;
 var items;try{items=JSON.parse(raw.textContent)}catch(e){items=[]}
 if(!items||!items.length)return;
 wrap.hidden=false;row.innerHTML='';
 items.forEach(function(p){
  var d=document.createElement('div');d.className='cd-up';
  var img=document.createElement('img');img.loading='lazy';img.alt='';img.src=p.image;
  var b=document.createElement('b');b.textContent=p.title;
  var sp=document.createElement('span');sp.textContent=p.priceText||money(p.price||0);
  var btn=document.createElement('button');btn.type='button';btn.textContent='+ Ekle';
  btn.addEventListener('click',function(){addUpsell(p.variantId,btn)});
  d.appendChild(img);d.appendChild(b);d.appendChild(sp);d.appendChild(btn);
  row.appendChild(d)
 })
}
function addUpsell(id,btn){
 btn.disabled=true;var orig=btn.textContent;
 fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
  .then(function(r){return r.json()}).then(function(){return refresh()})
  .then(function(){btn.textContent='Eklendi ✓';setTimeout(function(){btn.textContent=orig;btn.disabled=false},1600)})
  .catch(function(){btn.disabled=false;btn.textContent=orig})
}
window.KadooCart={
 open:function(){refresh().then(openDrawer)},
 close:closeDrawer,
 refreshAfterAdd:function(){return refresh().then(openDrawer)}
};
$$('[data-cart-toggle]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();window.KadooCart.open()})});
renderUpsell();
})();
